import { Component, OnInit, Inject, Optional } from '@angular/core';
import { AtpBasePageComponent } from '../atp-core/atp-base-page-component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { HttpService } from '../services/http.service';
import { AtpHttpErrorsService, AtpHttpErrorHandler } from '../atp-core/services/atp-http-errors.service';
import { FormGroup, FormControl } from '@angular/forms';
import { AtpValidators } from '../atp-core/atp-core';
import { IUser } from '../models';
import { AtpActionsPopup, AtpActionsPopupData } from '../atp-core/components/atp-actions-popup/atp-actions-popup.component';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html'
})
export class AuthComponent extends AtpBasePageComponent implements OnInit {

  constructor(private _router: Router, public api: HttpService, private _httpErrors: AtpHttpErrorsService, location: Location, @Optional() public dialogRef: MatDialogRef<AuthComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private _data: any, private _dialog: MatDialog) {
    super();
    if (_data) {
      this._data.baseUrl = location.path();
    }
  }

  form: FormGroup;

  ngOnInit() {
    this.form = new FormGroup({
      'login': new FormControl('', [
        AtpValidators.required,
        AtpValidators.pattern(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/),
      ]),
      'password': new FormControl('', [
        AtpValidators.required,
        AtpValidators.checkPassLanguage
      ])
    });
  }

  get loginErrorLabel(): string {
    let result = this.form.controls['login'].hasError('required') ? 'не введен.' : null;
    if (!result) result = this.form.controls['login'].hasError('pattern') ? 'введен неверно.' : null;
    return result;
  }

  get passwordErrorLabel(): string {
    let result = this.form.controls['password'].hasError('required') ? 'не введен.' : null;
    if (!result) result = this.form.controls['password'].hasError('checkPassLanguage') ? 'состоит из букв латинского алфавита и цифр, проверьте раскладку клавиатуры.' : null;
    return result;
  }

  isSubmited = false;

  submit(): void {
    if (this.isSubmited) return;
    this.isSubmited = true;

    this.form.controls['login'].markAsTouched();
    this.form.controls['password'].markAsTouched();

    if (this.form.invalid) {
      this.isSubmited = false;
      return;
    }

    this.sendAuthData(<string>this.form.controls['login'].value, <string>this.form.controls['password'].value, new FormData());
  }

  private sendAuthData(login: string, password: string, formData: FormData) {
    this.isBlockedPage = true;
    this.api.auth(login, password, formData).subscribe(
      (result: IUser) => {
        this.api.user = result;
        this.api.authEvent.next();

        this.isBlockedPage = false;

        if (this.dialogRef) {
          this.dialogRef.close(true);
          // TODO: обновление страницы
          // this._router.navigate([this._router.url]);
          this._router.navigate(['/']);
        }
        else {
          this._router.navigate(['/']);
        }
      },
      err => {
        if (err.status == 401) {
          let data = new AtpActionsPopupData('Ошибка', err.error, 'Отправить письмо с подтверждением', 'Закрыть');
          data.successBtnColor = 'primary';
          data.titleColor = '#f44336';

          this._dialog.open(AtpActionsPopup, { width: '450px', data }).afterClosed().subscribe(
            (result: boolean) => {
              if (result) {
                this.resend(login);
              }
            }
          );

          this.isBlockedPage = false;
        }
        else {
          this._httpErrors.process(err.status, null, this, [new AtpHttpErrorHandler(400, err.error, null)]);
        }

        this.isSubmited = false;
      }
    );
  }

  resend(login: string) {
    this.isBlockedPage = true;
    this.api.resendConfirmEmail(0, login).subscribe(
      (result: string) => {
        this.isBlockedPage = false;
        this._router.navigate(['/registration/confirmemail'], { queryParams: { email: result } });
      },
      err => {
        this._httpErrors.process(err.status, () => { this.resend(login); }, this, [new AtpHttpErrorHandler(400, err.error, null)]);
      }
    );
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

}
